// PROFORMA_FORM_EDIT_MODE_CHANGE
export const PROFORMA_FORM_EDIT_MODE_CHANGE = 'PROFORMA_FORM_EDIT_MODE_CHANGE' as const;

export const proformaFormEditModeChange = (isProformaFormInEditMode: boolean) => ({
	type: PROFORMA_FORM_EDIT_MODE_CHANGE,
	payload: isProformaFormInEditMode,
});

export type ProformaAction = ReturnType<typeof proformaFormEditModeChange>;
